import { type IconName, LandingIcon } from "./LandingIcon";

const PROBLEMS: readonly { icon: IconName; title: string; body: string }[] = [
  {
    icon: "trending-down",
    title: "Tu finca tira todo a gasto",
    body: "El 99% de fincas medianas registra cada peso de crianza como gasto operativo. Perdés ahorro fiscal legítimo y el patrimonio real de tu hato no aparece en el balance.",
  },
  {
    icon: "database",
    title: "Cuentas dormidas en tu contabilidad",
    body: "Tu plan de cuentas ya tiene la estructura correcta para activo biológico. Solo nadie las está usando. HATO las activa con un mapeo de una sola vez.",
  },
  {
    icon: "shield-warning",
    title: "EEFF débiles ante el banco",
    body: "Sin depreciación correcta del hato productivo, tus estados financieros subreportan tu patrimonio. El banco lee menos respaldo del que realmente tenés.",
  },
];

export function LandingProblem() {
  return (
    <section className="relative z-10 border-white/[0.06] border-b bg-brand-dark">
      <div
        aria-hidden
        className="pointer-events-none absolute top-0 bottom-0 left-1/3 hidden w-px bg-white/[0.06] md:block"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute top-0 bottom-0 left-2/3 hidden w-px bg-white/[0.06] md:block"
      />

      <div className="relative z-10 grid grid-cols-1 md:grid-cols-3">
        {PROBLEMS.map((p, i) => (
          <div
            key={p.title}
            className={`scroll-fade p-8 md:p-12 ${i < PROBLEMS.length - 1 ? "border-white/[0.06] border-b md:border-b-0" : ""}`}
          >
            <div className="mb-6 flex h-10 w-10 items-center justify-center rounded-xl border border-white/[0.08] bg-brand-panel text-primary-500 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
              <LandingIcon name={p.icon} size={20} />
            </div>
            <h3 className="mb-2 font-medium text-base text-white tracking-tight">{p.title}</h3>
            <p className="text-neutral-400 text-sm leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
